class loglist {
    constructor($scope, httpRequest) {
        // 初始化表单数据
        // 用户信息
        const userInfo = JSON.parse(localStorage.user_info)
        // 存储页面信息
        $scope.pageState = {
            idToken: localStorage.id_token,
            userInfo,
        }
        // 字典数据
        $scope.dictData = {}
        const typecodeArr = ['operate_type', 'operate_result']

        httpRequest.get_dictByTypeArr(typecodeArr).then((res) => {
            $scope.dictData = $.extend($scope.dictData, res.data.value)
            for (let i = 0, l = typecodeArr.length; i < l; i++) {
                const arr = [{ enumTypeCode: null, enumName: '全部', enumCode: null }]
                $scope.dictData[typecodeArr[i]] = arr.concat($scope.dictData[typecodeArr[i]])
            }
        })
    }
}

loglist.$inject = ['$scope', 'httpRequest']
export default loglist



// WEBPACK FOOTER //
// ./src/app/system/log/operation/loglist.js